import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";

const initialState: any = {
  enquiriesList: [],
  status:"pending"
};

export const getAllEnquiries = createAsyncThunk<any>(
  "enquiriesSlice/getAllEnquiries",
  async (_, thunkAPI) => {
    try {
      const response = await ApiClient("help-desk?limit=100");
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const enquiriesSlice = createSlice({
  name: "enquiriesSlice",
  initialState,
  reducers: {
    setEnquiriesList(state, action) {
      state.enquiriesList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEnquiries.pending,(state) => {
          state.status = "pending";
      });
    builder.addCase(getAllEnquiries.fulfilled, (state, action: PayloadAction<any>) => {
      state.enquiriesList = action?.payload?.data;
      state.status = "succeeded";
    });
    builder.addCase(getAllEnquiries.rejected,(state) => {
      state.status = "failed";
  });
  },
});

export const { setEnquiriesList } = enquiriesSlice.actions;
export default enquiriesSlice;
